var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM18.8697 11.5653C18.8697 14.5909 16.6895 17.0436 14.0001 17.0436C11.3108 17.0436 9.13058 14.5909 9.13058 11.5653C9.13058 8.53979 11.3108 6.08708 14.0001 6.08708C16.6895 6.08708 18.8697 8.53979 18.8697 11.5653ZM22.8965 22.0533C20.7008 24.4775 17.5282 26.0002 13.9999 26.0002C10.4719 26.0002 7.29949 24.4777 5.10385 22.0539C7.30316 19.6362 10.4746 18.1185 14.0005 18.1185C17.526 18.1185 20.6972 19.636 22.8965 22.0533Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.55c8b6a50fb6c15f71cbe2ea700fc364.svg";
export { ForwardRef as ReactComponent };